/* Afkar Plus - first-order pop-up (BeyondADS 19 Oct 2026, client doc 1.4, modelled on turnwise.in).
   Product pages only, after 20 s, at most once every 7 days (localStorage "afkarFirst").
   Never while the lucky spin is open, never while a spin prize is reserved in the cart (they cannot be combined),
   never if the code is already in the cart. "Apply" uses the REAL code FIRSTORDER (8% off, once per customer)
   via /discount/FIRSTORDER, which keeps it for checkout even when the bag is still empty. */
(function () {
  'use strict';
  if (window.__afoLoaded) return; window.__afoLoaded = true;
  var KEY = 'afkarFirst', WEEK = 7 * 864e5, CODE = 'FIRSTORDER', DELAY = 20000;
  function get(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var CSS = '.afo{position:fixed;left:50%;bottom:20px;z-index:2147482980;width:min(430px,calc(100vw - 24px));transform:translate(-50%,140%);transition:transform .45s cubic-bezier(.2,.8,.2,1);font-family:"Instrument Sans",sans-serif;color:#111}' +
    '.afo.is-in{transform:translate(-50%,0)}' +
    '.afo-card{position:relative;display:grid;grid-template-columns:86px minmax(0,1fr);gap:16px;align-items:center;padding:16px 44px 18px 16px;border-radius:20px;background:#fff;box-shadow:0 18px 48px rgba(17,17,17,.22);overflow:hidden}' +
    '.afo-tag{display:flex;align-items:center;justify-content:center;height:96px;border-radius:14px;background:#e31c63;color:#fff;transform:rotate(-6deg);box-shadow:0 8px 18px rgba(227,28,99,.35);text-align:center;font-size:13px;font-weight:800;font-style:italic;line-height:1.1;letter-spacing:-.01em;padding:6px}' +
    '.afo-title{margin:0 0 8px;font-size:17px;font-weight:800;line-height:1.25;letter-spacing:-.01em}' +
    '.afo-code{display:flex;align-items:center;gap:8px;margin:0 0 12px;font-size:12.5px;color:#5b5b5f}' +
    '.afo-code b{padding:4px 10px;border:1.5px dashed #e31c63;border-radius:8px;color:#111;font-size:13px;letter-spacing:.06em}' +
    '.afo-btn{appearance:none;width:100%;height:42px;border:0;border-radius:999px;background:#111;color:#fff;font:inherit;font-size:12.5px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;cursor:pointer}' +
    '.afo-btn:disabled{opacity:.7;cursor:default}' +
    '.afo-note{margin:8px 0 0;font-size:11px;color:#8a8a8f}' +
    '.afo-x{position:absolute;top:10px;right:10px;width:30px;height:30px;padding:0;border:0;border-radius:50%;background:#f4f4f5;color:#111;font-size:18px;line-height:1;cursor:pointer}' +
    '.afo-bar{position:absolute;left:0;bottom:0;height:3px;width:100%;background:#e31c63;transform-origin:left;transition:transform linear}' +
    'html.ap-sticky-on .afo{bottom:86px}' +
    '@media (max-width:749px){.afo{bottom:12px}.afo-card{grid-template-columns:64px minmax(0,1fr);gap:12px;padding:12px 40px 14px 12px}.afo-tag{height:72px;font-size:11px}.afo-title{font-size:15px}}';

  function cookieBannerUp() {
    var cmp = document.getElementById('usercentrics-cmp-ui') || document.getElementById('usercentrics-root');
    if (!cmp) return false;
    var r = cmp.getBoundingClientRect(), cs = getComputedStyle(cmp);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (r.height > 0) return true;
    var sr = cmp.shadowRoot, inner = sr && sr.querySelector('[role="dialog"], #uc-center-container, #uc-main-dialog, .cmp-wrapper');
    return !!(inner && inner.getBoundingClientRect().height > 0);
  }
  function blocked() {
    if (cookieBannerUp()) return true;
    var spin = document.querySelector('[data-asw]');
    if (spin && !spin.hidden) return true;
    var res = get('afkarSpinRes');
    if (res && res.code && res.until > Date.now()) return true;
    return false;
  }
  function show() {
    if (blocked()) { setTimeout(maybe, 15000); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var has = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === CODE; });
      if (has) return;
      build();
    }).catch(build);
  }
  function build() {
    if (document.querySelector('.afo')) return;
    set(KEY, { t: Date.now() });
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
    var el = document.createElement('div'); el.className = 'afo'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-label', 'First order offer');
    el.innerHTML = '<div class="afo-card"><span class="afo-tag">a little<br>surprise</span><div>' +
      '<p class="afo-title">Extra 8% off your first order</p>' +
      '<p class="afo-code">Promo code <b>' + CODE + '</b></p>' +
      '<button type="button" class="afo-btn" data-afo-apply>Apply</button>' +
      '<p class="afo-note">One use per customer. Taken off at checkout.</p></div>' +
      '<button type="button" class="afo-x" data-afo-x aria-label="Close">&times;</button><span class="afo-bar" data-afo-bar></span></div>';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    setTimeout(function () { el.classList.add('is-in'); }, 60);
    var bar = el.querySelector('[data-afo-bar]'), life = 25000;
    setTimeout(function () { bar.style.transitionDuration = life + 'ms'; bar.style.transform = 'scaleX(0)'; }, 100);
    var timer = setTimeout(close, life);
    function close() { clearTimeout(timer); el.classList.remove('is-in'); setTimeout(function () { el.remove(); }, 500); }
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-afo-x]')) { close(); return; }
      var b = e.target.closest('[data-afo-apply]'); if (!b) return;
      clearTimeout(timer); bar.style.display = 'none';
      b.disabled = true; b.textContent = 'Applying...';
      fetch('/discount/' + CODE, { credentials: 'same-origin' }).then(function () {
        b.textContent = 'Applied'; el.querySelector('.afo-note').textContent = 'FIRSTORDER is saved and will be taken off at checkout.';
        document.dispatchEvent(new CustomEvent('afkar:cart:updated', { detail: { source: 'first' } }));
        setTimeout(close, 3500);
      }).catch(function () { b.disabled = false; b.textContent = 'Apply'; });
    });
  }
  function maybe() {
    var s = get(KEY);
    if (s && s.t && Date.now() - s.t < WEEK) return;
    show();
  }
  var force = /[?&]afkar_first=1/.test(location.search);
  if (force) setTimeout(build, 600);
  else setTimeout(maybe, DELAY);
})();
